import Axios from 'axios';
import * as JSCookie from 'js-cookie';

export const API_ENDPOINTS = {
    BASE_URL: location.hostname === 'localhost' ? 'http://localhost:8081/' : 'https://api.isotopeticketing.com/',
    GRAPHQL_WS_URL: location.hostname === 'localhost' ? 'ws://localhost:8081/' : 'wss://api.isotopeticketing.com/',
    GRAPHQL_ENDPOINT: '',
    AUTH_EMAIL_PASS_ENDPOINT: 'auth/login',
    AUTH_GOOGLE_ENDPOINT: 'auth/google',
    AUTH_FACEBOOK_ENDPOINT: 'auth/facebook'
};

const token = JSCookie.get('token');

export const fetchAPI = Axios.create({
    baseURL: API_ENDPOINTS.BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        Authorization: token,
        Accept: 'application/json',
    },
});


// WEBPACK FOOTER //
// ./src/components/graphql/FetchApi.tsx